import { computed } from 'vue';
import { useFlag } from '@loadsmart/vue-feature-flags';

export function useYardInTransitFeature() {
  const featureFlagYardInTransit = useFlag('enable-yard-in-transit');

  const isYardInTransitEnabled = computed(() => Boolean(featureFlagYardInTransit.value?.enabled));

  /**
   * Whether the feature flag has resolved. Used to defer rendering the In Transit surfaces until
   * the flag is known, so the tab does not pop in a beat after the page has already painted.
   */
  const isYardInTransitReady = computed(() => Boolean(featureFlagYardInTransit.value?.ready));

  /** Enabled and resolved — what the In Transit surfaces should gate on. */
  const isYardInTransitVisible = computed(
    () => isYardInTransitReady.value && isYardInTransitEnabled.value
  );

  return {
    isYardInTransitEnabled,
    isYardInTransitReady,
    isYardInTransitVisible
  };
}
